import { getOr } from 'lodash/fp';
import { parseJSON } from 'helpers/safetyJSON';

const getRandomVariant = (variants) => {
  const [variantA, variantB] = variants;

  return Math.random() < variantA.probability / 100
    ? variantA.name
    : variantB.name;
};

const getWinnerVariantConfig = (experiment) => {
  const { id, name, active, variants } = experiment;
  const winnerVariant = getRandomVariant(variants);

  if (!active) {
    return;
  }

  return {
    id,
    name,
    active,
    winnerVariant,
  };
};

export default (cmsData) => {
  if (!cmsData) {
    return;
  }
  const experiments = getOr([], ['experiments'], parseJSON(cmsData));
  const experimentsConfig = {};

  // eslint-disable-next-line array-callback-return
  experiments.map((experiment) => {
    const winnerVariantConfig = getWinnerVariantConfig(experiment);

    if (winnerVariantConfig) {
      experimentsConfig[winnerVariantConfig.name] = winnerVariantConfig;
    }
  });

  return experimentsConfig;
};
